import { Injectable } from '@angular/core';
import { Settings } from '../core/settings';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UserPreferencesStorage {

    constructor(
        private readonly settings: Settings,
        private readonly http: HttpClient
    ) { }

    public get(key: string): Observable<string | null> {
        return this.http
            .get<string>(`${this.settings.apiUrl}/user-preferences-storage/items/${key}/value`)
            .pipe(map(response => response));
    }

    public set(key: string, value: string): Promise<void> {
        return this.http
            .put<void>(`${this.settings.apiUrl}/user-preferences-storage/items/${key}/value`, { value: value })
            .toPromise();
    }
}